import { atom } from 'recoil';

export const GLOBAL_NAV_OPEN = atom({
  key: 'globalNavOpen',
  default: false
});
